import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import * as Sentry from "@sentry/remix";
import { startTransition, StrictMode, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";
import { getPublicEnv } from "~/components/public-env";
import { replayIntegration } from "@sentry/remix";
import {
  redactSecretQuery,
  scrubSecretQuery,
} from "~/clean_arch/shared/utils/secretQuery";

Sentry.init({
  dsn: getPublicEnv("SENTRY_DSN"),
  tunnel: "/api/sentry/tunnel",
  environment: getPublicEnv("NODE_ENV"),
  integrations: [
    Sentry.browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches,
    }),
    replayIntegration,
  ],
  // Performance Monitoring
  tracesSampleRate: 0.5,
  // Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  // Emailed links arrive as ?token=; the pages move it out of the URL before
  // rendering, and whatever still names a URL is scrubbed on the way out.
  beforeSend: (event) => scrubSecretQuery(event),
  beforeSendTransaction: (event) => scrubSecretQuery(event),
  beforeBreadcrumb: (crumb) =>
    crumb.data
      ? {
          ...crumb,
          data: Object.fromEntries(
            Object.entries(crumb.data).map(([key, value]) => [
              key,
              typeof value === "string" ? redactSecretQuery(value) : value,
            ])
          ),
        }
      : crumb,
});

const hydrate = () => {
  startTransition(() => {
    hydrateRoot(
      document,
      <StrictMode>
        <RemixBrowser />
      </StrictMode>
    );
  });
};

if (window.requestIdleCallback) {
  window.requestIdleCallback(hydrate);
} else {
  // Safari doesn't support requestIdleCallback
  // https://caniuse.com/requestidlecallback
  window.setTimeout(hydrate, 1);
}
